import React from "react";
import { useEffect, useState } from "react";
import { Alert, Box, LinearProgress } from "@mui/material";

const Redirect = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 10
      );
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    setTimeout(function () {
      window.location.replace(
        "https://occ.server-eye.de/#/internal/fast-contact"
      );
    }, 5500);
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgress variant="determinate" value={progress} />{" "}
      <Alert severity="warning" sx={{ height: "10%", p: 2, fontWeight: "600" }}>
        Die von Ihnen gesuchte Seite wurde verschoben. Sie werden dorthin
        weitergeleitet!
      </Alert>
    </Box>
  );
};

export default Redirect;
